import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-shippigo-create',
  templateUrl: './admin-shippigo-create.component.html',
  styleUrls: ['./admin-shippigo-create.component.scss'],
})
export class AdminShippigoCreateComponent implements OnInit {
  carrierName: string;
  carrierNameError: string;
  userName: string;
  userNameError: string;
  password: string;
  passwordError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }

  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  userNameBlur() {
    this.userNameError = "";
    if (!this.userName) {
      this.userNameError = 'Please enter user name';
    }
  }

  passwordBlur() {
    this.passwordError = "";
    if (!this.password) {
      this.passwordError = 'Please enter password';
    }
  }

  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.userNameError = "";
    this.passwordError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.userName) {
      this.userNameError = 'Please enter user name';
    }
    if (!this.password) {
      this.passwordError = 'Please enter password';
    }
    if (this.carrierNameError != "" || this.userNameError != "" || this.passwordError != "") {
      this.g.loaderDisplay = "";
      return false;
    }

    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {
      "username": this.userName,
      "carrierCode": "SG",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "password": this.password
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shippigo', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }
}

